import { Paragraph } from '@unistocks/components/text/text';
import { formatPercentage } from '@unistocks/shared/localization/index.ts';
import React from 'react';
import { ThemeableStack, ThemeableStackProps, ViewProps } from 'tamagui';

export type ProgressBarProps = ThemeableStackProps & {
  fillColor?: ViewProps['bg'];
  /** Progress value between 0 and 1 (0% to 100%) */
  value: number;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  fillColor = '$color8',
  transition = 'quickLessBouncy',
  ...props
}) => {
  const fillWidth = `${value * 100}%` as const;
  const label = formatPercentage(value, { maximumFractionDigits: 0 });

  return (
    <ThemeableStack br={'$true'} bg={'$color3'} h={'$2'} w={'100%'} overflow="hidden" {...props}>
      <ThemeableStack
        transition={transition}
        animateOnly={['width']}
        flex={1}
        alignItems="center"
        justifyContent="center"
        bg={fillColor}
        w={fillWidth}
        borderTopEndRadius={value < 1 ? '$8' : undefined}
        borderBottomEndRadius={value < 1 ? '$8' : undefined}
        enterStyle={{ width: '0%' }}
      >
        <Paragraph fontWeight={'$7'} color={'$bodyFont'}>
          {label}
        </Paragraph>
      </ThemeableStack>
    </ThemeableStack>
  );
};

ProgressBar.displayName = 'ProgressBar';
